import type { CampusLocation, ReportReason, WorkOrderCategory, WorkOrderPriority, WorkOrderStatus } from './types';

export const OPEN_WORK_ORDER_STATUSES: WorkOrderStatus[] = ['OPEN', 'IN_PROGRESS', 'WAITING'];

export const WORK_ORDER_STATUS_LABEL: Record<WorkOrderStatus, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  WAITING: 'Waiting',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
};

export const WORK_ORDER_PRIORITY_LABEL: Record<WorkOrderPriority, string> = {
  LOW: 'Low',
  NORMAL: 'Normal',
  HIGH: 'High',
  URGENT: 'Urgent',
};

export const WORK_ORDER_CATEGORY_LABEL: Record<WorkOrderCategory, string> = {
  DAMAGE: 'Broken or damaged',
  POWER: 'Won’t turn on or charge',
  HARDWARE: 'Screen, keyboard, or other hardware',
  SOFTWARE: 'Apps or software',
  NETWORK: 'Wi-Fi or internet',
  ACCOUNT: 'Sign-in or account',
  ACCESSORY: 'Charger or accessory',
  OTHER: 'Something else',
};

export const CAMPUS_LOCATION_LABEL: Record<CampusLocation, string> = {
  ON_CAMPUS: 'On campus',
  OFF_CAMPUS: 'Off campus',
  UNKNOWN: 'Location unknown',
};

export const REPORT_REASON_LABEL: Record<ReportReason, string> = {
  ASSIGNED_TO_YOU: 'Assigned to you',
  ASSIGNED_TO_ROOM: 'Assigned to your room',
  IN_YOUR_ROOM: 'Kept in your room',
};
